module.exports = __webpack_public_path__ + "media/images/calendar/march-44d5f63c8ca46484d8396f97bd2cc24a.jpg";